import React, { Component } from 'react';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import { withSnackbar } from 'react-simple-snackbar';

class ChangePassword extends Component{
    static contextType = AuthContext;
    state = {
        oldpassword : '',
        newpassword : '',
        confirmpassword : '',
        hidden: true
    }

    resetFormHandler = () => {
        this.setState({
            oldpassword : '',
            newpassword : '',
            confirmpassword : ''
        }, function (){
            this.props.history.push(process.env.PUBLIC_URL+'/settings/')
        })
    }

    handlePasswordChange = (event) => {
        const {name,value} = event.target;
        this.setState({
            [name] : value
        })
    }

    handleFormSubmit = (event) => {
        event.preventDefault()
        if(this.state.newpassword.trim().length < 6){
            this.props.openSnackbar('New password should be equal to or greater than 6 characters')
            return false;
        }
        if(this.state.oldpassword.trim()===''){
            this.props.openSnackbar('Please enter old password')
            return false;
        }
        else if(this.state.newpassword.trim()===''){
            this.props.openSnackbar('Please enter new password')
            return false;
        }
        else if(this.state.confirmpassword.trim()===''){
            this.props.openSnackbar('Please enter confirm password')
            return false;
        }
        else if(this.state.newpassword.trim() !== this.state.confirmpassword.trim()){
            this.props.openSnackbar('New password and confirm password should be same')
            return false;
        }

        const formBody = "oldpassword="+ encodeURIComponent(this.state.oldpassword.trim())+'&newpassword='+encodeURIComponent(this.state.newpassword.trim());
        fetch(ApiBaseUrl + "/consumer/update_password",
            {
                method: 'POST',
                body: formBody,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    this.props.openSnackbar(result.message)
                    if(result.success)
                        this.props.history.push(process.env.PUBLIC_URL+'/settings/')
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden });
    }

    render(){
        return(
            <React.Fragment>
                <div className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7 col-lg-5 mx-auto custom-mt-15 px--xs-0">
                                <div className="changepswd-box cg--green">
                                    <form autoComplete="off" onSubmit={this.handleFormSubmit}>
                                        <p className="old--text">Please enter your current password to set a new one</p>
                                        <div className="changepswd-rows">
                                            <label>Old Password</label>
                                            <div className="eye">
                                                <input type="password" className="form-control" onChange={this.handlePasswordChange} name="oldpassword" value={this.state.oldpassword} placeholder="Enter your current password"/>
                                            </div>
                                        </div>
                                        <div className="changepswd-rows">
                                            <label>New Password</label>
                                            <div className="eye">
                                                <input id="password-field" type={this.state.hidden ? 'password' : 'text'} className="form-control" onChange={this.handlePasswordChange} name="newpassword" value={this.state.newpassword} placeholder="Enter a new password"/>
                                                <span onClick={this.toggleShow.bind(this)} toggle="#password-field"
                                                          className={this.state.hidden ? 'fa fa-fw field-icon toggle-password fa-eye-slash' : 'fa fa-fw field-icon toggle-password fa-eye'}></span>
                                            </div>
                                        </div>
                                        <div className="changepswd-rows">
                                            <label>Confirm Password</label>
                                            <div className="eye">
                                                <input type="password" className="form-control" onChange={this.handlePasswordChange} name="confirmpassword" value={this.state.confirmpassword} placeholder="Confirm your new password"/>
                                            </div>
                                        </div>
                                        <div className="btn-rowstack text-center float-right">
                                            <button className="cancel-btn red-btn d--xs-none" type="reset" onClick={this.resetFormHandler}>Cancel</button>
                                            <button className="entry-btn cancel-btn grad-on d-none d-lg-block next-btn" type="submit" data-toggle="modal" data-target="#pswd--chngd">Next</button>
                                            <button className="entry-btn grad-on d-lg-none" type="submit">
                                                <img src={`${process.env.PUBLIC_URL}/image/back_white.png`} alt=""/></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(ChangePassword,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});